import { FbwA32NxExpandedMarketingSeo } from "../../../content/templateMarketing/fbw-a32nx-seo";
import { AircraftAddonTemplate } from "../../../lib/model/addonTemplate";
import fbwA32NXFront from "../../images/templates/fbw-a32nx-front.png";

export const fbwA32NXExpandedTemplate: AircraftAddonTemplate = {
  type: "aircraft",
  title: "FBW A32NX (Expanded)",
  id: "fbw-a32nx-expanded",
  platforms: ["msfs"],
  image: fbwA32NXFront,
  infoMarketingBlurb: FbwA32NxExpandedMarketingSeo,
  content: [
    {
      title: "Preliminary Cockpit Preparation",
      roles: ["cockpitPreparation"],
      content: [
        {
          header: "Aircraft Setup",
        },
        {
          item: "Engine Master 1 & 2",
          setting: "Off",
        },
        {
          item: "Engine Mode Selector",
          setting: "Norm",
        },
        {
          item: "WX Radar",
          setting: "Off",
        },
        {
          item: "Windshear / PWS",
          setting: "Off",
        },
        {
          item: "WX Radar Gain",
          setting: "Auto / Cal",
        },
        {
          item: "WX Radar Mode",
          setting: "As Required",
        },
        {
          item: "Landing Gear Lever",
          setting: "Verify Down",
        },
        {
          item: "Wipers",
          setting: "Off",
        },
        {
          header: "Battery Verification",
        },
        {
          item: "Battery 1 & 2",
          setting: "Verify Off",
        },
        {
          item: "Battery 1 & 2 Voltages",
          setting: "Verify > 25.5V",
        },
        {
          item: "Battery 1 & 2",
          setting: "Auto",
        },
        {
          item: "External Power",
          setting: "As Required",
        },
        {
          header: "APU Fire Test / APU Start",
        },
        {
          item: "APU Fire Button",
          setting: "In & Guarded",
        },
        {
          item: "APU Fire Agent",
          setting: "Verify Off",
        },
        {
          item: "APU Fire Test",
          setting: "Test",
        },
        {
          item: "APU Master",
          setting: "On",
        },
        {
          item: "APU Start",
          setting: "On",
        },
        {
          header: "Air Conditioning",
        },
        {
          item: "APU Bleed",
          setting: "On",
        },
        {
          header: "Cargo Heat",
        },
        {
          item: "Temperature Selector",
          setting: "As Required",
        },
        {
          header: "Cockpit Lighting",
        },
        {
          item: "Cockpit Lights",
          setting: "As Required",
        },
        {
          header: "EFB / ACARS Initialization",
        },
        {
          item: "EFB",
          setting: "Start",
        },
        {
          item: "ACARS",
          setting: "Initialize",
        },
        {
          item: "Engine & Aircraft Type",
          setting: "Verify",
        },
        {
          item: "FM Database Validity",
          setting: "Verify",
        },
        {
          item: "Flight Number",
          setting: "Insert / Verify",
        },
        {
          item: "From/To",
          setting: "Insert / Verify",
        },
        {
          header: "ECAM / Logbook Verification",
        },
        {
          item: "ECAM RCL",
          setting: "Press 3 Seconds",
        },
        {
          item: "Logbook",
          setting: "Verify",
        },
        {
          item: "MEL/CDL Items",
          setting: "Verify Dispatch Cond",
        },
        {
          item: "Aircraft Acceptance",
          setting: "Perform",
        },
      ],
    },
    {
      title: "Preliminary Cockpit Preparation (contd)",
      roles: ["cockpitPreparation"],
      content: [
        {
          header: "Preliminary Performance Determination",
        },
        {
          item: "Airfield Data",
          setting: "Obtain",
        },
        {
          item: "Preliminary Takeoff Data",
          setting: "Compute",
        },
        {
          item: "Preliminary Takeoff Data",
          setting: "Crosscheck",
        },
        {
          header: "Operation Engineering Bulletins",
        },
        {
          item: "OEB",
          setting: "Verify",
        },
        {
          header: "Before Walkaround",
        },
        {
          item: "Oxygen",
          setting: "Verify Pressure",
        },
        {
          item: "HYD Reservoir Level",
          setting: "Verify Normal",
        },
        {
          item: "Engine Oil Quantity",
          setting: "Verify Normal",
        },
        {
          item: "Flaps Lever",
          setting: "Verify Position",
        },
        {
          item: "Speedbrakes",
          setting: "Retracted & Disarmed",
        },
        {
          item: "Parking Brake Accu Press",
          setting: "Verify",
        },
        {
          item: "Parking Brake",
          setting: "On",
        },
        {
          item: "Break Pressure Indicator",
          setting: "Verify",
        },
        {
          item: "Yellow Electric Pump",
          setting: "Verify Off",
        },
        {
          item: "Chocks",
          setting: "Verify In Place",
        },
        {
          item: "Parking Brake",
          setting: "Off",
        },
        {
          item: "Brake Pedals",
          setting: "Press Max Pressure",
        },
        {
          item: "Brake Pressure",
          setting: "Verify",
        },
        {
          item: "Brake Pedals",
          setting: "Release",
        },
        {
          item: "Parking Brake",
          setting: "On",
        },
        {
          item: "Emergency Equipment",
          setting: "Verify Onboard",
        },
        {
          item: "Rain Repellant",
          setting: "Verify Press & Qty",
        },
        {
          item: "Rear/Ovhd Circuit Breakers",
          setting: "Verify",
        },
        {
          item: "Gear Pins & Covers",
          setting: "Onboard & Stowed",
        },
      ],
    },
    "page-break",
    {
      title: "Cockpit Preparation",
      roles: ["cockpitPreparation"],
      content: [
        {
          header: "Overhead Panel",
        },
        {
          item: "All White Lights",
          setting: "Off",
        },
        {
          item: "Recorder GND CTL",
          setting: "On",
        },
        {
          item: "Loudspeaker Volume",
          setting: "Both Sides Off",
        },
        {
          item: "ACP INT/RAD",
          setting: "INT",
        },
        {
          item: "Interphone Volume",
          setting: "Release",
        },
        {
          item: "CVR Test",
          setting: "Accomplish",
        },
        {
          item: "Capt & Purs/Capt",
          setting: "As Required",
        },
        {
          item: "AII IR Mode Selectors",
          setting: "Nav",
        },
        {
          item: "Strobe Lights",
          setting: "Off",
        },
        {
          item: "Beacon Lights",
          setting: "Off",
        },
        {
          item: "Nav & Logo Lights",
          setting: "As Required",
        },
        {
          item: "Remaining Exterior Lights",
          setting: "As Required",
        },
        {
          item: "Seat Belt Signs",
          setting: "On / Auto",
        },
        {
          item: "No Smoking Signs",
          setting: "Auto",
        },
        {
          item: "Emergency Exit Lights",
          setting: "Arm",
        },
        {
          item: "Probe/Window Heat",
          setting: "Verify Auto",
        },
        {
          item: "Landing Elevation",
          setting: "Auto",
        },
        {
          item: "Pack Flow",
          setting: "As Required",
        },
        {
          item: "ECAM ELEC Page",
          setting: "Press",
        },
        {
          item: "BAT 1 & 2",
          setting: "Off Then On",
        },
        {
          item: "ENG 1 & ENG 2 Fire",
          setting: "In & Guarded",
        },
        {
          item: "Fire Agent 1 & 2 Lights",
          setting: "Verify Off",
        },
        {
          item: "ENG 1 & ENG 2 Fire Test",
          setting: "Accomplish",
        },
        {
          item: "Audio Switching",
          setting: "Norm",
        },
        {
          header: "Center Instrument Panel",
        },
        {
          item: "ISIS",
          setting: "Verify",
        },
        {
          item: "Clock",
          setting: "Verify / Set",
        },
        {
          item: "A/SKID & N/W Steering",
          setting: "On",
        },
        {
          header: "Pedestal",
        },
        {
          item: "INT knob",
          setting: "Press Out / Verify Volume",
        },
        {
          item: "VHF",
          setting: "Verify",
        },
        {
          item: "HF",
          setting: "Verify",
        },
        {
          item: "Annunciator Lights",
          setting: "Test",
        },
        {
          item: "Annunicator Lights",
          setting: "Bright",
        },
        {
          item: "Cockpit Door",
          setting: "Verify Operation",
        },
        {
          item: "Cockpit Door Mech. Override",
          setting: "Verify",
        },
        {
          item: "All Selectors",
          setting: "Verify Norm",
        },
      ],
    },
    {
      title: "Cockpit Preparation (contd)",
      roles: ["cockpitPreparation"],
      content: [
        {
          header: "Pedestal",
        },
        {
          item: "Thrust Lever",
          setting: "Idle",
        },
        {
          item: "ENG Master Switches",
          setting: "Off",
        },
        {
          item: "ENG Mode",
          setting: "Norm",
        },
        {
          item: "ACCU PRESS",
          setting: "Verify",
        },
        {
          item: "Parking Brake",
          setting: "Verify On",
        },
        {
          item: "Brakes Pressure Indicator",
          setting: "Verify",
        },
        {
          item: "Gravity Gear Extension",
          setting: "Stowed",
        },
        {
          item: "ATC",
          setting: "Stby",
        },
        {
          item: "Altitude Reporting",
          setting: "On",
        },
        {
          item: "ATC SYS 1",
          setting: "Select",
        },
        {
          header: "Radio Management Panel",
        },
        {
          item: "RMP",
          setting: "Verify On",
        },
        {
          item: "Green Nav Light",
          setting: "Verify Off",
        },
        {
          item: "SEL Light",
          setting: "Verify Off",
        },
        {
          item: "COM Frequencies",
          setting: "Tune",
        },
        {
          header: "ATC Datalink Communication",
        },
        {
          item: "MSG Record",
          setting: "Erase",
        },
        {
          header: "FMGS Preparation",
        },
        {
          item: "Engine & Aircraft Type",
          setting: "Verify",
        },
        {
          item: "FM Database Validity",
          setting: "Verify",
        },
        {
          item: "Navaid Deselection",
          setting: "As Required",
        },
        {
          item: "Flight Plan Initialization",
          setting: "Complete",
        },
        {
          item: "ADIRS Initialization",
          setting: "As Appropriate",
        },
        {
          item: "F-PLN A Page",
          setting: "Complete & Verified",
        },
        {
          item: "Winds",
          setting: "As Appropriate",
        },
        {
          item: "F-PLN",
          setting: "Verify",
        },
        {
          item: "Secondary Flight Plan",
          setting: "As Appropriate",
        },
        {
          item: "Radio Nav",
          setting: "Verify",
        },
        {
          item: "ZFW/ZFWCG",
          setting: "Insert",
        },
        {
          item: "Block Fuel",
          setting: "Insert",
        },
        {
          item: "TO Shift",
          setting: "Insert As Required",
        },
        {
          item: "V1, VR, V2",
          setting: "Insert",
        },
        {
          item: "Flex Temp",
          setting: "Insert",
        },
        {
          item: "Thrust Red/Accel Altitude",
          setting: "Set / Verify",
        },
        {
          item: "Engine Out Accel Altitude",
          setting: "Set / Verify",
        },
        {
          item: "Flaps / THS Reminder",
          setting: "Insert",
        },
        {
          item: "Preset Speeds",
          setting: "As Required",
        },
        {
          item: "FMS Preparation",
          setting: "Verify",
        },
      ],
    },
    "page-break",
    {
      title: "Cockpit Preparation (contd)",
      roles: ["cockpitPreparation"],
      content: [
        {
          header: "Glareshield",
        },
        {
          item: "Barometric Reference",
          setting: "Set",
        },
        {
          item: "FD",
          setting: "Verify On",
        },
        {
          item: "ILS/LS",
          setting: "As Required",
        },
        {
          item: "ND Mode and Range",
          setting: "As Required",
        },
        {
          item: "ADF/VOR",
          setting: "As Required",
        },
        {
          item: "SPD/MACH Window",
          setting: "Dashed",
        },
        {
          item: "HDG V/S - TRK FPA",
          setting: "HDG V/S",
        },
        {
          item: "Altitude Window",
          setting: "Initial Expected Alt",
        },
        {
          header: "Lateral Console",
        },
        {
          item: "Crew Supply",
          setting: "Verify On",
        },
        {
          item: "Loudspeakers",
          setting: "On",
        },
        {
          item: "INT Reception Knob",
          setting: "Press Out - Adjust",
        },
        {
          item: "INT/RAD Switch",
          setting: "INT",
        },
        {
          header: "Instrument Panel",
        },
        {
          item: "PFD and ND Brightness",
          setting: "As Required",
        },
        {
          item: "Loudspeaker",
          setting: "Set",
        },
        {
          item: "PFD",
          setting: "Verify",
        },
        {
          item: "ND",
          setting: "Verify",
        },
        {
          header: "ECAM Control Panel",
        },
        {
          item: "PRESS Pushbutton",
          setting: "Press",
        },
        {
          item: "STS Pushbutton",
          setting: "PRESS",
        },
        {
          header: "ADIRS",
        },
        {
          item: "IRS Align",
          setting: "Verify",
        },
        {
          header: "Takeoff Briefing",
        },
        {
          item: "Takeoff Briefing",
          setting: "Perform",
        },
      ],
    },
    {
      title: "Before Pushback",
      roles: ["beforePushback"],
      content: [
        {
          header: "Before Start Clearance",
        },
        {
          item: "Final Loadsheet",
          setting: "Verify",
        },
        {
          item: "ZFW/ZFWCG",
          setting: "Verify/Revise",
        },
        {
          item: "Fuel on Board",
          setting: "Verify",
        },
        {
          item: "Takeoff Data",
          setting: "Check",
        },
        {
          item: "FMS PERF TO Page",
          setting: "PF Select",
        },
        {
          item: "FMS F-PLN Page",
          setting: "PM Select",
        },
        {
          item: "External Power",
          setting: "Verify Avail",
        },
        {
          item: "External Power",
          setting: "Disconnect",
        },
        {
          item: "Before Start Checklist",
          setting: "To the Line",
        },
        {
          header: "At Start Clearance",
        },
        {
          item: "Pushback/Start Clearance",
          setting: "Obtain",
        },
        {
          item: "ATC",
          setting: "Set for Operation",
        },
        {
          item: "Windows and Doors",
          setting: "Verify Closed",
        },
        {
          item: "Slides",
          setting: "Verify Armed",
        },
        {
          item: "Beacon",
          setting: "On",
        },
        {
          item: "Thrust Levers",
          setting: "Idle",
        },
        {
          item: "ACCU PRESS",
          setting: "Verify",
        },
      ],
    },
    {
      title: "Engine Start",
      roles: ["engineStart"],
      content: [
        {
          item: "Engine Mode Selector",
          setting: "IGN/Start",
        },
        {
          item: "Engine 2 Start",
          setting: "Announce",
        },
        {
          item: "ENG Master 2",
          setting: "On",
        },
        {
          item: "Engine 1 Start",
          setting: "Announce",
        },
        {
          item: "ENG Master 1",
          setting: "On",
        },
      ],
    },
    {
      title: "After Start",
      roles: ["afterEngineStart"],
      content: [
        {
          item: "Engine Mode Selector",
          setting: "Norm",
        },
        {
          item: "APU Bleed",
          setting: "Off",
        },
        {
          item: "Engine Anti-Ice",
          setting: "As Required",
        },
        {
          item: "Wing Anti-Ice",
          setting: "As Required",
        },
        {
          item: "APU Master",
          setting: "Off",
        },
        {
          item: "Ground Spoilers",
          setting: "Arm",
        },
        {
          item: "Rudder Trim",
          setting: "Verify Zero",
        },
        {
          item: "Flaps",
          setting: "Set for Takeoff",
        },
        {
          item: "Flaps",
          setting: "Verify Position",
        },
        {
          item: "Pitch Trim",
          setting: "Set",
        },
        {
          item: "ECAM STS Reminder",
          setting: "Not Displayed",
        },
        {
          item: "N/W STEER DISC Memo",
          setting: "Not Displayed",
        },
        {
          item: "Clear to Disconnect",
          setting: "Announce",
        },
        {
          item: "After Start Checklist",
          setting: "Complete",
        },
      ],
    },
    "page-break",
    {
      title: "Taxi",
      roles: ["taxi"],
      content: [
        {
          item: "Taxi Clearance",
          setting: "Obtain",
        },
        {
          item: "Nose Lights",
          setting: "Taxi",
        },
        {
          item: "Runway Turnoff Lights",
          setting: "On",
        },
        {
          item: "Parking Brakes",
          setting: "Off",
        },
        {
          item: "Brake Pressure",
          setting: "Verify Zero",
        },
        {
          item: "Thrust Lever",
          setting: "As Required",
        },
        {
          item: "Brake Pedals",
          setting: "Press",
        },
        {
          item: "Brakes",
          setting: "Verify",
        },
        {
          item: "Flight Controls",
          setting: "Checked",
        },
        {
          item: "ATC Clearance",
          setting: "Confirm",
        },
        {
          item: "F-PLAN (SID/Transition)",
          setting: "Verify",
        },
        {
          item: "Initial Climb Speed/Limit",
          setting: "Verify",
        },
        {
          item: "Cleared Altitude on FCU",
          setting: "Set",
        },
        {
          item: "HDG on FCU",
          setting: "As Required",
        },
        {
          item: "Both FD",
          setting: "Verify On",
        },
        {
          item: "PFD/ND",
          setting: "Verify",
        },
        {
          item: "Takeoff Briefing",
          setting: "Confirm",
        },
        {
          item: "Radar",
          setting: "On",
        },
        {
          item: "PWS",
          setting: "Auto",
        },
        {
          item: "ATC Code/Mode",
          setting: "Confirm & Set",
        },
        {
          item: "Terrain on ND",
          setting: "As Required",
        },
        {
          item: "Autobrake",
          setting: "Max",
        },
        {
          item: "Takeoff Config",
          setting: "Test",
        },
        {
          item: "TO Memo",
          setting: "Verify No Blue",
        },
        {
          item: "Cabin Report",
          setting: "Receive",
        },
        {
          item: "Before Takeoff Checklist",
          setting: "To the LIne",
        },
      ],
    },
    {
      title: "Before Takeoff",
      roles: ["beforeTakeoff"],
      content: [
        {
          item: "Line-Up Clearance",
          setting: "Obtain",
        },
        {
          item: "Strobes",
          setting: "On",
        },
        {
          item: "TCAS Mode",
          setting: "TA/RA",
        },
        {
          item: "Approach Path",
          setting: "Clear of Traffic",
        },
        {
          item: "Cabin Crew",
          setting: "Advise",
        },
        {
          item: "Sliding Table",
          setting: "Stow",
        },
        {
          item: "Takeoff Runway",
          setting: "Confirm",
        },
        {
          item: "Pack 1 & 2",
          setting: "As Required",
        },
        {
          item: "Before Takeoff Checklist",
          setting: "Complete",
        },
      ],
    },
    {
      title: "Takeoff",
      roles: ["takeoff"],
      content: [
        {
          item: "Takeoff Clearance",
          setting: "Obtained",
        },
        {
          item: "Nose Lights",
          setting: "Takeoff",
        },
        {
          item: "Runway Turnoff Lights",
          setting: "On",
        },
        {
          item: "Landing Lights",
          setting: "On",
        },
        {
          item: "Takeoff",
          setting: "Announce",
        },
        {
          item: "Thrust Levers",
          setting: "50% N1",
        },
        {
          item: "Symmetric Thrust",
          setting: "Verify",
        },
        {
          item: "Thrust Levers",
          setting: "Flex/TOGA",
        },
        {
          item: "Chrono",
          setting: "Start",
        },
        {
          item: "FMA",
          setting: "Announce",
        },
        {
          header: "Positive Climb",
        },
        {
          item: "Landing Gear",
          setting: "Retracted",
        },
        {
          item: "Autopilot",
          setting: "As Required",
        },
        {
          header: "At Thrust Reduction Altitude",
        },
        {
          item: "Thrust levers",
          setting: "Climb",
        },
        {
          item: "Pack 1 & 2",
          setting: "On",
        },
      ],
    },
    {
      title: "After Takeoff",
      roles: ["takeoff"],
      content: [
        {
          item: "APU Bleed",
          setting: "As Required",
        },
        {
          item: "APU Master",
          setting: "As Required",
        },
        {
          item: "TCAS Mode",
          setting: "TA/RA",
        },
        {
          item: "Engine Anti-Ice",
          setting: "As Required",
        },
        {
          item: "Wing Anti-Ice",
          setting: "As Required",
        },
        {
          item: "After TO/Climb Checklist",
          setting: "To the Line",
        },
      ],
    },
    {
      title: "Climb",
      roles: ["climbOut"],
      content: [
        {
          item: "PF MCDU",
          setting: "PERF CLB",
        },
        {
          item: "PM MCDU",
          setting: "F-PLN",
        },
        {
          item: "Engine Anti-Ice",
          setting: "As Required",
        },
        {
          item: "Radar",
          setting: "As Appropriate",
        },
        {
          header: "At 10,000 Feet",
        },
        {
          item: "Landing Lights",
          setting: "Retract",
        },
        {
          item: "Seat Belts",
          setting: "As Required",
        },
        {
          item: "EFIS",
          setting: "As Required",
        },
        {
          item: "ECAM Memo",
          setting: "Review",
        },
        {
          item: "Navaids",
          setting: "Clear",
        },
        {
          item: "Secondary Flight Plan",
          setting: "As Required",
        },
        {
          item: "OPT/MAX Altitude",
          setting: "Verify",
        },
        {
          header: "At Transition Altitude",
        },
        {
          item: "Baro Ref",
          setting: "STD/Crosscheck",
        },
        {
          item: "ISIS Baro Ref",
          setting: "STD",
        },
      ],
    },
    "page-break",
    {
      title: "Cruise",
      roles: ["cruise"],
      content: [
        {
          item: "ECAM Memo",
          setting: "Review",
        },
        {
          item: "ECAM SD Pages",
          setting: "Review",
        },
        {
          item: "Flight Progress",
          setting: "Verify",
        },
        {
          item: "Step Flight Level",
          setting: "As Appropriate",
        },
        {
          item: "Radar",
          setting: "As Appropriate",
        },
      ],
    },
    {
      title: "Descent Preparation",
      roles: ["beforeDescent"],
      content: [
        {
          item: "Weather & Landing Info",
          setting: "Obtain",
        },
        {
          item: "Nav Charts",
          setting: "Prepare",
        },
        {
          item: "Landing Performance",
          setting: "Compute",
        },
        {
          item: "ARRIVAL Page",
          setting: "Complete/Verify",
        },
        {
          item: "F-PLN A Page",
          setting: "Verify",
        },
        {
          item: "DES Wind",
          setting: "Verify",
        },
        {
          item: "PERF CRUISE Page",
          setting: "Verify",
        },
        {
          item: "PERF DES Page",
          setting: "Verify",
        },
        {
          item: "PERF APPR Page",
          setting: "Complete/Verify",
        },
        {
          item: "PERF GO-AROUND Page",
          setting: "Verify/Modify",
        },
        {
          item: "RAD NAV Page",
          setting: "Verify",
        },
        {
          item: "SEC F-PLN Page",
          setting: "As Required",
        },
        {
          item: "GPWS LDG FLAP 3",
          setting: "As Required",
        },
        {
          item: "Landing Elevation",
          setting: "Verify",
        },
        {
          item: "Autobrake",
          setting: "As Required",
        },
        {
          item: "Approach Briefing",
          setting: "Perform",
        },
        {
          item: "Terrain on ND",
          setting: "As Required",
        },
        {
          item: "Radar",
          setting: "Adjust as Appropriate",
        },
        {
          item: "Engine Anti-Ice",
          setting: "As Required",
        },
        {
          item: "Wing Anti-Ice",
          setting: "As Required",
        },
        {
          item: "Descent Clearance",
          setting: "Obtain",
        },
        {
          item: "Cleared Altitude on FCU",
          setting: "Set",
        },
      ],
    },
    {
      title: "Descent",
      roles: ["descent"],
      content: [
        {
          header: "At Transition Altitude",
        },
        {
          item: "Baro Ref",
          setting: "Set",
        },
        {
          item: "ISIS Baro Ref",
          setting: "Set",
        },
        {
          item: "ECAM Status",
          setting: "Verify",
        },
        {
          header: "At 10,000 Feet",
        },
        {
          item: "Landing Lights",
          setting: "On",
        },
        {
          item: "Seat Belt Signs",
          setting: "On",
        },
        {
          item: "EFIS Options",
          setting: "CSTR",
        },
        {
          item: "ILS/LS",
          setting: "As Required",
        },
        {
          item: "RAD Navaids",
          setting: "Selected/Identified",
        },
        {
          item: "Nav Accuracy",
          setting: "Verify",
        },
        {
          item: "Approach Checklist",
          setting: "Perform",
        },
      ],
    },
    "page-break",
    {
      title: "Approach",
      roles: ["approach"],
      content: [
        {
          item: "F-PLN Sequencing",
          setting: "Adjust",
        },
        {
          item: "Approach Phase",
          setting: "Verify/Activate",
        },
        {
          item: "Managed Speed",
          setting: "Verify",
        },
        {
          item: "Flight Path",
          setting: "Monitor",
        },
        {
          item: "Speed Brakes",
          setting: "As Required",
        },
        {
          item: "Radar",
          setting: "Adjust as Appropriate",
        },
        {
          item: "Nav Accuracy",
          setting: "Monitor",
        },
        {
          header: "At Green Dot Speed",
        },
        {
          item: "Flaps 1",
          setting: "Selected",
        },
        {
          item: "TCAS Mode",
          setting: "TA or TA/RA",
        },
        {
          header: "At 2,000 Feet AGL",
        },
        {
          item: "Flaps 2",
          setting: "Selected",
        },
        {
          item: "Landing Gear",
          setting: "Down",
        },
        {
          item: "Autobrake",
          setting: "Confirm",
        },
        {
          item: "Ground Spoilers",
          setting: "Arm",
        },
        {
          item: "Nose Lights",
          setting: "Takeoff",
        },
        {
          item: "Runway Turnoff Lights",
          setting: "On",
        },
        {
          header: "Final Approach Segment",
        },
        {
          item: "Flaps 3",
          setting: "Selected",
        },
        {
          item: "ECAM WHEEL SD Page",
          setting: "Check",
        },
        {
          item: "Landing Gear",
          setting: "Confirm Three Green",
        },
        {
          item: "Flaps Full",
          setting: "Selected",
        },
        {
          item: "A/THR",
          setting: "In Speed Mode or Off",
        },
        {
          item: "Wing Anti-Ice",
          setting: "Off",
        },
        {
          item: "Sliding Table",
          setting: "Stow",
        },
        {
          item: "All EFB",
          setting: "Stow",
        },
        {
          item: "Landing Memo",
          setting: "Verify No Blue",
        },
        {
          item: "Cabin Report",
          setting: "Receive",
        },
        {
          item: "Cabin Crew",
          setting: "Advise",
        },
        {
          item: "Landing Checklist",
          setting: "Complete",
        },
      ],
    },
    {
      title: "Landing",
      roles: ["landing"],
      content: [
        {
          item: "Thrust Levers",
          setting: "Reverse",
        },
        {
          item: "Ground Spoilers",
          setting: "Verify/Announce",
        },
        {
          item: "Reverses",
          setting: "Verify/Announce",
        },
        {
          item: "Brakes",
          setting: "As Required",
        },
        {
          item: "Deceleration",
          setting: "Verify/Announce",
        },
        {
          header: "At 70 Knots",
        },
        {
          item: "Seventy Knots",
          setting: "Announce",
        },
        {
          item: "Thrust Levers",
          setting: "Reverse Idle",
        },
        {
          header: "At Taxi Speed",
        },
        {
          item: "Reversers",
          setting: "Stow",
        },
        {
          header: "Before 20 Knots",
        },
        {
          item: "Autobrake",
          setting: "Disengage",
        },
      ],
    },
    {
      title: "Go Around",
      roles: ["goAround"],
      content: [
        {
          item: "Thrust Levers",
          setting: "TOGA",
        },
        {
          item: "Rotation",
          setting: "Perform",
        },
        {
          item: "Go Around",
          setting: "Announce",
        },
        {
          item: "Flaps",
          setting: "As Required",
        },
        {
          item: "FMA",
          setting: "Verify/Announce",
        },
        {
          item: "Positive Climb",
          setting: "Announce",
        },
        {
          item: "Landing Gear",
          setting: "Up",
        },
        {
          item: "NAV or HDG Mode",
          setting: "As Required",
        },
        {
          item: "Autopilot",
          setting: "As Required",
        },
        {
          header: "At GA Thrust Redution Altitude",
        },
        {
          item: "THrust Levers",
          setting: "Climb",
        },
        {
          header: "At GA Acceleration Altitude",
        },
        {
          item: "Ground Spoilers",
          setting: "Disarm",
        },
        {
          item: "Nose Lights",
          setting: "Off",
        },
        {
          item: "Runway Turnoff Lights",
          setting: "Off",
        },
        {
          item: "Other Exterior Lights",
          setting: "As Required",
        },
        {
          item: "After TO/Climb Checklist",
          setting: "To the Line",
        },
      ],
    },
    "page-break",
    {
      title: "After Landing",
      roles: ["afterLanding"],
      content: [
        {
          item: "Ground Spoilers",
          setting: "Disarm",
        },
        {
          item: "Landing Lights",
          setting: "Retract",
        },
        {
          header: "When Leaving Runway",
        },
        {
          item: "Strobes",
          setting: "Off",
        },
        {
          item: "Nose Lights",
          setting: "Taxi",
        },
        {
          item: "Other Exterior Lights",
          setting: "As Required",
        },
        {
          header: "Taxi",
        },
        {
          item: "Radar",
          setting: "Off",
        },
        {
          item: "PWS",
          setting: "Off",
        },
        {
          item: "Engine Mode Selector",
          setting: "Norm",
        },
        {
          item: "Flaps",
          setting: "Retract",
        },
        {
          item: "TCAS",
          setting: "Standby",
        },
        {
          item: "ATC",
          setting: "As Required",
        },
        {
          item: "APU",
          setting: "Start",
        },
        {
          item: "Anti-Ice",
          setting: "As Required",
        },
        {
          item: "Brake Temperature",
          setting: "Verify",
        },
        {
          item: "Brake Fan",
          setting: "As Required",
        },
        {
          item: "After Landing Checklist",
          setting: "Complete",
        },
      ],
    },
    {
      title: "Parking",
      roles: ["parking"],
      content: [
        {
          item: "ACCU PRESS Indicator",
          setting: "Verify",
        },
        {
          item: "Parking Brake",
          setting: "On",
        },
        {
          item: "BRAKE PRESS",
          setting: "Verify",
        },
        {
          item: "Anti-Ice",
          setting: "Off",
        },
        {
          item: "APU Bleed",
          setting: "On",
        },
        {
          item: "Slides",
          setting: "Verify Disarmed",
        },
        {
          item: "Seat Belt Signs",
          setting: "Off",
        },
        {
          item: "Beacon",
          setting: "Off",
        },
        {
          item: "Other Exterior Lights",
          setting: "As Required",
        },
        {
          item: "Ground Contact",
          setting: "Establish",
        },
        {
          item: "Fuel Pumps",
          setting: "Off",
        },
        {
          item: "ATC",
          setting: "Standby",
        },
        {
          item: "IRS Performance",
          setting: "Verify",
        },
        {
          item: "Fuel Quantity",
          setting: "Verify",
        },
        {
          item: "STS Pushbutton",
          setting: "Press",
        },
        {
          item: "Brake Fan",
          setting: "Off",
        },
        {
          item: "Parking Brake",
          setting: "As Required",
        },
        {
          item: "Display Unit Brightness",
          setting: "Dim",
        },
        {
          item: "Parking Checklist",
          setting: "Complete",
        },
      ],
    },
    {
      title: "Securing the Aircraft",
      roles: ["securing"],
      content: [
        {
          item: "Park",
          setting: "On",
        },
        {
          item: "Oxygen Crew Supply",
          setting: "Off",
        },
        {
          item: "All IR Mode Selectors",
          setting: "Off",
        },
        {
          item: "Exterior Lights",
          setting: "Off",
        },
        {
          item: "Maintenance Bus",
          setting: "As Required",
        },
        {
          item: "APU Bleed",
          setting: "Off",
        },
        {
          item: "APU Master",
          setting: "Off",
        },
        {
          item: "Emergency Exit Lights",
          setting: "Off",
        },
        {
          item: "Signs",
          setting: "Off",
        },
        {
          item: "External Power",
          setting: "As Required",
        },
        {
          item: "Battery 1 & 2",
          setting: "Off",
        },
        {
          item: "Securing Checklist",
          setting: "Complete",
        },
      ],
    },
  ],
};
